<div class="success-container relative flex items-center justify-center min-h-screen text-center text-gray-200 bg-custom-bg">
  <div class="absolute inset-0 backdrop-blur-sm backdrop-brightness-50"></div>

  <div class="relative z-10 flex flex-col items-center gap-6 p-12 shadow-2xl rounded-xl border border-white max-w-md bg-[linear-gradient(180deg,rgba(15,22,55,0.85)_20.25%,rgba(2,2,8,0.85)_100%)]" style="background-clip: padding-box; border-radius: 16px; position: relative; overflow: hidden;">
    <div class="absolute inset-0 bg-gradient-to-br from-blue-900 to-gray-900 opacity-40 rounded-xl blur-lg -z-10"></div>

    <div *ngIf="loading" class="loading-spinner flex flex-col items-center text-lg text-gray-300 backdrop-blur-md p-6 rounded-lg shadow-lg bg-[rgba(255,255,255,0.05)] ">
      <div class="spinner-border animate-spin inline-block w-12 h-12 border-4 rounded-full border-t-transparent mb-4"></div>
      <p>Processing your subscription...</p>
    </div>

    <div *ngIf="!loading && successMessage" class="success-content flex flex-col items-center gap-6">
      <div class="success-icon text-7xl text-green-500 mb-4 drop-shadow-lg animate-pulse rounded-full p-2">✔️</div>
      <h2 class="text-gray-200 text-xl font-extrabold tracking-wider leading-snug max-w-sm border-b border-gray-700 pb-2">
        {{ successMessage }}
      </h2>
      <button (click)="redirectTohome()" class="bg-gradient-to-r from-green-500 to-green-700 text-white px-12 py-4 rounded-full text-lg font-semibold tracking-widest hover:bg-gradient-to-br hover:from-green-600 hover:to-green-800 transition-all duration-300 shadow-md transform hover:shadow-xl border border-green-500 hover:border-green-600">
        Return Home
      </button>
    </div>
  </div>
</div>
